export { SpeechIcon } from './speech'
